export function formatDateTime(date: Date): string {
  // Pad the month, day, hours, minutes, and seconds with leading zeros if necessary
  const pad = (num: number) => num.toString().padStart(2, '0');

  // Extract and format date and time components
  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1); // Months are zero-based
  const year = date.getFullYear();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  // Construct the formatted date-time string
  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}

// Function to get the current date in NgbDateStruct format
export const getCurrentDate= (): { year: number, month: number, day: number } => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1; // Months are zero-based, so add 1
  const day = now.getDate();
  return { year, month, day };
}

// Function to get the date three months ago in NgbDateStruct format
export const getThreeMonthsAgo=(): { year: number, month: number, day: number } => {
  const now = new Date();
  const threeMonthsAgo = new Date(now);
  threeMonthsAgo.setMonth(now.getMonth() - 3);
  
  // If the subtraction results in a negative month, adjust the year and month accordingly.
  if (threeMonthsAgo.getMonth() > now.getMonth()) {
    threeMonthsAgo.setFullYear(now.getFullYear() - 1);
    threeMonthsAgo.setMonth(12 + (now.getMonth() - 3));
  }

  const year = threeMonthsAgo.getFullYear();
  const month = threeMonthsAgo.getMonth() + 1; // Months are zero-based, so add 1
  const day = threeMonthsAgo.getDate();
  return { year, month, day };
}

export function formatDate(date: Date): string {
  const day = date.getDate();
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
}